import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../css/home/highlight_list.scss';
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

$(function() {

    const $window = $(window);
    const winW = $window.width();

    if (winW < 480) return;

    const $swiper = '.tab_swiper';
    const container = $swiper + ' .swiper';
    const pagination = $swiper + ' .swiper-pagination';
    const button_next = $swiper + ' .swiper-button-next';
    const button_prev = $swiper + ' .swiper-button-prev';

    const mySwiper = new Swiper(container, {
        modules: [Navigation, Pagination, A11y],
        slidesPerView: 9,
        navigation: {
            nextEl: button_next,
            prevEl: button_prev,
        },
        breakpoints: {
            320: {
                slidesPerView: 3,
            },
            640: {
                slidesPerView: 5,
            },
            860: {
                slidesPerView: 9,
            },
        },
    });
});